import { useState, useContext, useEffect } from 'react'
import { PatrimonioContext } from '../../../contexts/patrimonioProvider'
import { UserContext } from '../../../contexts/userProvider'
import { BiPlus, BiEdit, BiTrash, BiTransfer } from 'react-icons/bi'
import { MdClose } from 'react-icons/md'
import Cadastro from '../Grupos/cadastro'
import TransferTable from '../Grupos/TransferTable'
import DataTable from '../../Table'

const Grupos = () => {
    const { grupos, equipamentos, equipamentosByGrupo, updateGrupoEquipamentos, deletarGrupo } = useContext(PatrimonioContext)
    const { setAlert } = useContext(UserContext)
    const [newGrupos, setNewGrupos] = useState([])
    const [grupoSelecionado, setGrupoSelecionado] = useState(null)
    const [cadastroModal, setCadastroModal] = useState(false)
    const [transferModal, setTransferModal] = useState(false)
    const [editModal, setEditModal] = useState(false)
    const [novosEquipamentos, setNovosEquipamentos] = useState([])
    const [equipamentosDoGrupo, setEquipamentosDoGrupo] = useState([])
    const [leftTableData, setLeftTableData] = useState([])
    const [rightTableData, setRightTableData] = useState([])

    useEffect(() => {
        let nGrupos = grupos ? [...grupos] : []
        setNewGrupos(nGrupos)
    }, [grupos])

    useEffect(() => {
        let nEquipamentos = equipamentos ? [...equipamentos] : []
        nEquipamentos.sort((a, b) => a.nome.localeCompare(b.nome))
        setNovosEquipamentos(nEquipamentos)
    }, [equipamentos])

    useEffect(() => {
        if (grupoSelecionado && transferModal) {
            console.log("SELEÇÃOO DE GRUPO" , grupoSelecionado)
            receberEquipamentosDoGrupo()
        }
        
    }, [grupoSelecionado?.id, grupoSelecionado?.id_modelo, transferModal])

    const receberEquipamentosDoGrupo = async () => {
        if (!grupoSelecionado) return
        try {
            const dados = await equipamentosByGrupo(grupoSelecionado)
            setEquipamentosDoGrupo(dados || [])
        } catch (error) {
            console.error('Erro ao buscar equipamentos do grupo:', error)
            setEquipamentosDoGrupo([])
        }
    }

    const handleAddGrupo = () => {
        setCadastroModal(true)
    }

    const handleEditGrupo = (grupo) => {
        setGrupoSelecionado(grupo)
        setEditModal(true)
    }

    const handleTransferGrupo = (grupo) => {
        // Reset completo de todos os estados relacionados à transferência
        setLeftTableData([])
        setRightTableData([])
        setEquipamentosDoGrupo([]) // reset para array vazio
        setGrupoSelecionado(null) // Limpa primeiro
        setTransferModal(false) // Garante que o modal feche se já estiver aberto
        
        // Usa setTimeout para garantir que o reset seja aplicado antes de abrir novamente
        setTimeout(() => {
            // Busca o grupo atualizado da lista para garantir dados recentes
            const grupoAtualizado = newGrupos.find(g => g.id === grupo.id) || grupo
            setGrupoSelecionado(grupoAtualizado)
            setTransferModal(true)
        }, 10)
    }

    const handleDeleteGrupo = async (grupo) => {
        setAlert({
            type: 'warning',
            placeholder: `Tem certeza que deseja excluir o grupo "${grupo.nome}"? Esta ação não pode ser desfeita.`,
            visible: true,
            confirm: true,
            title: 'Confirmar Exclusão',
            onConfirm: async () => {
                try {
                    const success = await deletarGrupo(grupo.id)
                    if (success) {
                        setAlert({
                            type: 'success',
                            placeholder: 'Grupo excluído com sucesso!',
                            visible: true,
                            confirm: false,
                            title: 'Sucesso'
                        })
                    }
                } catch (error) {
                    setAlert({
                        type: 'negative',
                        placeholder: 'Erro ao excluir grupo. Tente novamente.',
                        visible: true,
                        confirm: false,
                        title: 'Erro'
                    })
                }
            }
        })
    }

    const handleNewEquipamento = async () => {
        if (!grupoSelecionado) {
            setAlert({
                type: 'warning',
                placeholder: 'Nenhum grupo selecionado!',
                visible: true,
                confirm: false,
                title: 'Atenção!'
            })
            return
        }

        try {
            let nGroup = {}
            // Coleta ids dos itens da tabela da direita (dados completos, sem paginação)
            const collectedIds = (rightTableData || [])
                .map(item => item?.id_modelo ?? item?.id)
                .filter(Boolean)
                .map(String)
            // Remove duplicados e ordena para comparação estável
            const uniqueSortedIds = Array.from(new Set(collectedIds)).sort()
            // let oldIds = grupoSelecionado?.id_modelo?.split(',').filter(Boolean).map(String).sort()
            nGroup.id_modelo = uniqueSortedIds.join(',')
            nGroup.updated_at = new Date().toISOString().slice(0, 19).replace('T', ' ')
            nGroup.id = grupoSelecionado.id

            // Verifica se houve modificações (comparação por conjunto, ignorando ordem)
            const currentIdsSorted = (grupoSelecionado?.id_modelo
                ? String(grupoSelecionado.id_modelo).split(',').filter(Boolean).map(String)
                : []
            ).sort()

            if (uniqueSortedIds.join(',') === currentIdsSorted.join(',')) {
                setAlert({
                    type: 'warning',
                    placeholder: 'Não houve modificações nos equipamentos do grupo!',
                    visible: true,
                    confirm: false,
                    title: 'Atenção!'
                })
                return
            }

            const dado = await updateGrupoEquipamentos(nGroup)
            
            if (dado) {
                // Atualiza os dados do grupo
                await receberEquipamentosDoGrupo()

                // Fecha o modal e limpa os dados
                // closeAllModals()
                setTransferModal(false)
                setCadastroModal(false)
                setEditModal(false)
                setGrupoSelecionado(null)
                setLeftTableData([])
                setRightTableData([])
                setEquipamentosDoGrupo([])
                return dado
                
            }
        } catch (error) {
            console.error('Erro ao atualizar equipamentos do grupo:', error)
            setAlert({
                type: 'negative',
                placeholder: 'Erro ao atualizar equipamentos do grupo. Tente novamente.',
                visible: true,
                confirm: false,
                title: 'Erro'
            })
        }
    }

    const closeAllModals = () => {
        setCadastroModal(false)
        setTransferModal(false)
        setEditModal(false)
        setGrupoSelecionado(null)
        setLeftTableData([])
        setRightTableData([])
        setEquipamentosDoGrupo([])
    }

    // Prepara dados para a tabela padrão
    const preparedGruposData = newGrupos.map(grupo => ({
        ...grupo,
        qtd_equipamentos: grupo.id_modelo ? grupo.id_modelo.split(',').filter(id => id.trim()).length : 0,
        created_at_formatted: grupo.created_at ? new Date(grupo.created_at).toLocaleDateString('pt-BR') : '-',
        updated_at_formatted: grupo.updated_at ? new Date(grupo.updated_at).toLocaleDateString('pt-BR') : '-'
    }))

    // Headers da tabela padrão
    const tableHeaders = [
        {
            key: 'nome',
            label: 'Nome',
            sortable: true,
            tooltip: 'Nome do grupo de equipamentos'
        },
        {
            key: 'created_at_formatted',
            label: 'Data Criação',
            sortable: true,
            tooltip: 'Data de criação do grupo'
        },
        {
            key: 'updated_at_formatted',
            label: 'Última Atualização',
            sortable: true,
            tooltip: 'Data da última atualização do grupo'
        },
        {
            key: 'qtd_equipamentos',
            label: 'Qtd. Equipamentos',
            tooltip: 'Quantidade de equipamentos no grupo',
            render: (item) => (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-vox-blue-100 text-vox-blue-800 dark:bg-vox-blue-900/30 dark:text-vox-blue-300">
                    {item.qtd_equipamentos}
                </span>
            )
        },
        {
            key: 'actions',
            label: 'Ações',
            tooltip: 'Ações disponíveis para o grupo',
            actions: {
                equipamentos: (id) => {
                    const grupo = newGrupos.find(g => g.id === id)
                    if (grupo) handleTransferGrupo(grupo)
                },
                editar: (id) => {
                    const grupo = newGrupos.find(g => g.id === id)
                    if (grupo) handleEditGrupo(grupo)
                },
                deletar: (id) => {
                    const grupo = newGrupos.find(g => g.id === id)
                    if (grupo) handleDeleteGrupo(grupo)
                }
            }
        }
    ]

    return (
        <div className="max-w-7xl mx-auto p-6 space-y-8">
            {/* Header */}
            <div className="bg-gradient-to-r from-vox-blue-50 to-vox-green-50 dark:from-vox-blue-900/20 dark:to-vox-green-900/20 border border-vox-blue-200 dark:border-vox-blue-700 rounded-xl p-6 shadow-sm">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="w-12 h-12 bg-vox-blue-500 rounded-lg flex items-center justify-center">
                            <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                            </svg>
                        </div>
                        <div>
                            <h1 className="text-2xl font-bold text-vox-blue-900 dark:text-vox-blue-100">Grupos de Equipamentos</h1>
                            <p className="text-vox-blue-700 dark:text-vox-blue-300">Gerencie grupos e associações de equipamentos</p>
                        </div>
                    </div>

                    <button
                        onClick={handleAddGrupo}
                        data-tour-id="grupos:novo"
                        className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-vox-green-600 to-vox-green-700 hover:from-vox-green-700 hover:to-vox-green-800 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-vox-green-500 focus:ring-offset-2"
                    >
                        <BiPlus className="w-5 h-5 mr-2" />
                        Novo Grupo
                    </button>
                </div>
            </div>

            {/* Tabela de Grupos */}
            <DataTable
                key={newGrupos.length + (newGrupos.reduce((sum, g) => sum + (g.id_modelo?.length || 0), 0))}
                data={preparedGruposData}
                headers={tableHeaders}
                docTitle="Grupos de Equipamentos"
                exportButton={false}
            />

            {/* Modal de Cadastro */}
            {cadastroModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-md w-full mx-4">
                        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
                            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                                {editModal ? 'Editar Grupo' : 'Novo Grupo'}
                            </h2>
                            <button
                                onClick={closeAllModals}
                                className="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200"
                            >
                                <MdClose size={24} />
                            </button>
                        </div>
                        <div className="p-0">
                            <Cadastro
                                grupo={editModal ? grupoSelecionado : null}
                                setCadastroModal={closeAllModals}
                                isEdit={editModal}
                            />
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Edição */}
            {editModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-md w-full mx-4">
                        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
                            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Editar Grupo</h2>
                            <button
                                onClick={closeAllModals}
                                className="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200"
                            >
                                <MdClose size={24} />
                            </button>
                        </div>
                        <div className="p-0">
                            <Cadastro
                                grupo={grupoSelecionado}
                                setCadastroModal={closeAllModals}
                                isEdit={true}
                            />
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Transferência */}
            {transferModal && grupoSelecionado && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
                    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-7xl w-full max-h-[90vh] overflow-hidden">
                        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
                            <div>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                                    Gerenciar Equipamentos - {grupoSelecionado.nome}
                                </h2>
                                <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                                    Adicione ou remova equipamentos deste grupo
                                </p>
                            </div>
                            <button
                                onClick={closeAllModals}
                                className="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200"
                            >
                                <MdClose size={24} />
                            </button>
                        </div>

                        <div className="p-6 overflow-y-auto max-h-[calc(90vh-200px)]">
                            <TransferTable
                                key={`${grupoSelecionado?.id}-${grupoSelecionado?.id_modelo}`}
                                equipamentos={novosEquipamentos}
                                equipamentosDoGrupo={equipamentosDoGrupo}
                                leftTableData={leftTableData}
                                setLeftTableData={setLeftTableData}
                                rightTableData={rightTableData}
                                setRightTableData={setRightTableData}
                            />
                        </div>

                        <div className="p-6 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700">
                            <div className="flex justify-end gap-3">
                                <button
                                    onClick={closeAllModals}
                                    className="px-6 py-3 bg-gray-200 dark:bg-gray-600 text-gray-800 dark:text-gray-200 font-medium rounded-lg hover:bg-gray-300 dark:hover:bg-gray-500 transition-colors duration-200"
                                >
                                    Cancelar
                                </button>
                                <button
                                    onClick={handleNewEquipamento}
                                    className="px-6 py-3 bg-gradient-to-r from-vox-blue-600 to-vox-blue-700 hover:from-vox-blue-700 hover:to-vox-blue-800 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-vox-blue-500 focus:ring-offset-2"
                                >
                                    <BiTransfer className="w-5 h-5 mr-2 inline" />
                                    Salvar Alterações
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Grupos
